import React from 'react'
import DefaultDashboard from '../../../Components/Dashboard/Default'
import { useAuth } from '../../../Context/AuthContext';
import { Card, CardBody, Container, Row, Col } from 'reactstrap';
import { ShieldOff } from 'react-feather';
import { H3, P } from '../../../AbstractElements';

export default function Default() {
  const { hasPermission } = useAuth();

  if (!hasPermission('dashboard.view')) {
    return (
      <div className='page-body'>
        <Container fluid>
          <Row className="justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 160px)' }}>
            <Col md={7} lg={5} className="text-center">
              <Card
                className="border-0 shadow-lg position-relative overflow-hidden"
                style={{
                  borderRadius: '24px',
                  boxShadow: '0 20px 50px -10px rgba(0, 0, 0, 0.08)',
                  background: '#ffffff',
                }}
              >
                {/* Decorative Top Accent Bar */}
                <div
                  style={{
                    height: '5px',
                    width: '100%',
                    background: 'linear-gradient(90deg, #ef4444 0%, #f97316 100%)',
                  }}
                />

                <CardBody className="p-4 p-md-5">
                  {/* Shield Icon Container */}
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: '84px',
                      height: '84px',
                      background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(249, 115, 22, 0.15) 100%)',
                      color: '#ef4444',
                      border: '1px solid rgba(239, 68, 68, 0.2)',
                    }}
                  >
                    <ShieldOff size={40} />
                  </div>

                  {/* Category Pill */}
                  <div>
                    <span
                      className="badge bg-light-danger text-danger mb-3 px-3 py-2 rounded-pill fw-bold"
                      style={{ fontSize: '0.75rem', letterSpacing: '0.8px', textTransform: 'uppercase' }}
                    >
                      Permission Restricted
                    </span>
                  </div>

                  {/* Heading & Subtitle */}
                  <H3 className="fw-bold text-dark mb-2">Access Restricted</H3>
                  <P
                    className="text-muted mb-0 px-lg-2"
                    style={{ fontSize: '0.95rem', lineHeight: '1.6' }}
                  >
                    You don't have the necessary administrative privileges to view the dashboard metrics.
                    Please contact your system administrator if you believe this is an error.
                  </P>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className='page-body'>
      <DefaultDashboard />
    </div>
  )
}